// React and Hooks.
import React, {createContext, useEffect} from "react";
import { useLocalStorage } from "react-use";
import PropTypes from "prop-types";
import {disableBodyScroll, enableBodyScroll} from "body-scroll-lock";

// Create the Accessibility context.
export const AccessibilityContext = createContext({});

/**
 * Accessibility Provider.
 * This provider manages the state of all potential accessibility Functionalities and Settings.
 * The following operations are performed here:
 * - Switch Themes
 * - Simple Design Mode Toggle
 * - Switch Font Sizes
 */
const AccessibilityProvider = ({ children }) => {
  /**
   * Simple Design Mode Variables
   */
  const [simpleDesign, setSimpleDesign] = useLocalStorage("simple-design", false);
  const [theme, setTheme] = useLocalStorage("theme", "light");

  /**
   * Toggle Simple Design Mode
   */
  const toggleSimpleDesign = () => {
    setSimpleDesign(!simpleDesign);
    document.body.setAttribute("data-design", simpleDesign ? "standard" : "simple");
  };

  /**
   * Toggle High Contrast Mode
   */
  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
    document.documentElement.dataset.theme = theme === "dark" ? "light" : "dark";
  };

  useEffect(() => {
    document.body.setAttribute("data-design", simpleDesign ? "simple" : "standard");
    document.documentElement.dataset.theme = (theme === "dark" ? "dark" : "light");
  }, [])

  /**
   * The context value provides all necessary values and functions.
   */
  const value = {
    simpleDesign,
    setSimpleDesign,
    toggleSimpleDesign,
    theme,
    toggleTheme
  };

  return (
    <AccessibilityContext.Provider value={value}>
      {children}
    </AccessibilityContext.Provider>
  );
};

AccessibilityProvider.propTypes = {
  children: PropTypes.node
};

export default AccessibilityProvider;
